import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable()
export class LocalDevHttpInterceptor implements HttpInterceptor {
  /** ADD HERE EVERYTHING USEFUL FOR LOCAL DEVELOPMENT */

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // eslint-disable-next-line no-console

    if (environment.name?.toLowerCase().startsWith('local')) {
      console.warn('[LocalDevHttpInterceptor] This interceptor for dev is running');

      const modifiedRequest = req.clone({
        setHeaders: {
          'ngrok-skip-browser-warning': 'true',
        },
      });

      return next.handle(modifiedRequest);
    }

    return next.handle(req);
  }
}
